import { render, staticRenderFns } from "./DebtReceiptTemplate.vue?vue&type=template&id=56759312&scoped=true"
import script from "./DebtReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./DebtReceiptTemplate.vue?vue&type=script&lang=js"
import style0 from "./DebtReceiptTemplate.vue?vue&type=style&index=0&id=56759312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56759312",
  null
  
)

export default component.exports